import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { addPanel } from 'common/api/v1/panelsCompanies';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { addPanelsModalActions } from '../reducer';

import fetchPanelsIds from './fetchPanelsIds';
import filterItems from './filterItems';

export default (filterData, item, callback = null) =>
    (dispatch) => {
        dispatch(addPanelsModalActions[BULK_UPDATE_ITEMS]());

        const newValues = { ...item, ref: item.id };
        delete newValues.id;
        delete newValues.status_flag;
        delete newValues.created_at;
        delete newValues.updated_at;

        addPanel(newValues)
            .then(() => {
                dispatch(addPanelsModalActions[BULK_UPDATE_ITEMS_SUCCESS]());
                dispatch(fetchPanelsIds());
                if (!isEmpty(filterData)) dispatch(filterItems(filterData));
                if (callback) callback();
                showToast({ body: i18next.t('It was successfully added') });
            })
            .catch((error) => {
                dispatch(
                    addPanelsModalActions[BULK_UPDATE_ITEMS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
                showReponseErrorsAsAlert(dispatch, error?.response);
            });
    };
